import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/operLog',
  title: window.language['menu.log.operateLog'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/OperLog/index.js